var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"dollars-progress-bar",class:_vm.backgroundClasses,style:(`width: ${_vm.progressBarPercentage}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }